import React, { useEffect, useState } from "react";
import "./blogs.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SkeletonCard from "../../components/Skeleton/SkeletonCard";
import Modal2 from "../../components/modalsus2026/ModalSus";
import Busqueda_cont from "./busqueda";
import IdeasForm from "../../components/ideasForm/IdeasForm";

const Blogs = () => {
    const [t, i18n] = useTranslation("ideas_libertad");
    const [t2] = useTranslation("global");
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [offset, setOffset] = useState(14);
    const [loadingMore, setLoadingMore] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);
    const [searchInput, setSearchInput] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [hasMore, setHasMore] = useState(true);
    const [sortOrder, setSortOrder] = useState("recent");
    const [isSearchMode, setIsSearchMode] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const categoria = queryParams.get("categoria");
    const [showIdeasModal, setShowIdeasModal] = useState(false);
    const SIMPLE_LAYOUT_LIMIT = 15;
    const EDITORIAL_LAYOUT_LIMIT = 14;

    const [variableRetornada, setVariableRetornada] = useState(null);


    const handleRetorno = (valor) => {
        setVariableRetornada(valor);
    };

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Mi Blog',
            event_label: label,
            value: 1
        });
    };

    useEffect(() => {

        if (!categoria) {
            fetchBlogs();
        }

    }, [i18n.language, categoria]);

    useEffect(() => {

        if (categoria) {

            setActiveCategory(categoria);

            fetchBlogs({
                category: categoria,
                offset: 0
            });

            // Limpiar query param de la URL
            //navigate("/" + i18n.language + "/Mi-blog", { replace: true });
        }

    }, [categoria, i18n.language]);

    const fetchBlogs = async ({ category = null, search = "", offset = 0, append = false, limit = (category || search)
        ? SIMPLE_LAYOUT_LIMIT
        : EDITORIAL_LAYOUT_LIMIT, sort = sortOrder } = {}) => {
        try {
            setLoading(true);

            const url = buildUrl({ category, search, offset, limit, sort });

            const res = await fetch(url);
            const data = await res.json();
            setHasMore(data.length >= limit);

            if (append) {
                setBlogs(prev => [...prev, ...data]);
            } else {
                setBlogs(data);
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).toUpperCase();
    };

    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const openModal2 = () => {


        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };


    const getReadingTime = (txtresumen) => {
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {

            const partes = txtresumen.split("||");

            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim() + " MIN";
            }
        }

        const i = Math.floor(Math.random() * 5) + 1;
        return i + " MIN";
    };

    const cleanResumen = (txt) => {
        if (!txt) return "";
        return txt.split("||")[0];
    };



    const loadMore = async () => {
        try {
            setLoadingMore(true);

            const newOffset = blogs.length;

            const url = buildUrl({
                category: activeCategory,
                search: searchTerm,
                offset: newOffset,
                limit: 12,
                sort: sortOrder
            });

            const res = await fetch(url);
            const data = await res.json();

            setHasMore(data.length >= 12);

            setBlogs(prev => [...prev, ...data]);

            setOffset(newOffset + 12);

        } catch (err) {
            console.error(err);
        } finally {
            setLoadingMore(false);
        }
    };

    const handleCategoryClick = (category) => {

        if (activeCategory === category) {

            setActiveCategory(null);
            setOffset(0);
            setHasMore(true);
            setSearchTerm("");
            setIsSearchMode(false);

            fetchBlogs({
                category: null,
                offset: 0
            });

            return;
        }

        setActiveCategory(category);
        setOffset(0);
        setHasMore(true);
        setSearchTerm("");
        setIsSearchMode(false);

        trackAnalyticsClick('Mi Blog - Categoria: '+category);

        fetchBlogs({
            category,
            offset: 0
        });
    };

    const handleSearch = () => {

        setSearchTerm(searchInput);

        setOffset(0);
        setHasMore(true);
        setActiveCategory(null);

        setIsSearchMode(searchInput.trim() !== "");

        trackAnalyticsClick('Busqueda: '+searchInput);

        fetchBlogs({
            search: searchInput,
            offset: 0,
            sort: sortOrder
        });
    };

    const buildUrl = ({
        category = null,
        search = "",
        offset = 0,
        limit = 14,
        sort = "recent"
    }) => {
        const base = process.env.REACT_APP_API_URL;

        const sortParam =
            sort === "old"
                ? "&sort=Asce"
                : "&sort=Desc";

        // 🔎 búsqueda
        if (search && search.length >= 1) {
            let url = `${base}/blogs/search/by-title?offset=${offset}&next=${limit}&lang=${i18n.language}&words=${search}${sortParam}`;

            if (category) {
                url += `&category=${category}`;
            }

            return url;
        }

        // 📂 categoría
        if (category) {
            return `${base}/blogs/by-category/${category}?offset=${offset}&next=${limit}&lang=${i18n.language}${sortParam}`;
        }

        // 📰 todos
        return `${base}/blogs/n?offset=${offset}&next=${limit}&lang=${i18n.language}${sortParam}`;
    };

    const sortedBlogs = [...blogs].sort((a, b) => {
        if (sortOrder === "old") {
            return new Date(a.fecha) - new Date(b.fecha);
        }

        return new Date(b.fecha) - new Date(a.fecha);
    });

    const resetFilters = () => {
        console.log("variable: " + variableRetornada);
        setSearchTerm("");
        setSearchInput("");
        setActiveCategory(null);
        setSortOrder("");
        setOffset(0);
        setHasMore(true);
        setIsSearchMode(false);



        fetchBlogs({
            category: null,
            search: "",
            sort: "",
            offset: 0
        });
    };

    const getCategoryName = (item) => {

        // Si hay filtro activo, usar el label traducido
        if (activeCategory) {

            const categoryMap = {
                "liderazgo": t('categorias.categoria-5'),
                "educacion": t('categorias.categoria-2'),
                "estado-de-derecho": t('categorias.categoria-7'),
                "medio-ambiente": t('categorias.categoria-4'),
                "libertad": t('categorias.categoria-1'),
                "arte-y-cultura": t('categorias.categoria-3'),
                "innovacion": t('categorias.categoria-6'),
                "prosperidad-incluyente": t('categorias.categoria-9'),
                "biblioteca": t('categorias.categoria-8'),
            };

            return categoryMap[activeCategory]?.toUpperCase() || "";
        }

        // fallback normal
        return item.categorias?.[0]?.nombre?.toUpperCase() || "";
    };


    const getCategoryTag = (categoryName) => {

        const reverseCategoryMap = {
            [t('categorias.categoria-5').toLowerCase()]: "liderazgo",
            [t('categorias.categoria-2').toLowerCase()]: "educacion",
            [t('categorias.categoria-7').toLowerCase()]: "estado-de-derecho",
            [t('categorias.categoria-4').toLowerCase()]: "medio-ambiente",
            [t('categorias.categoria-1').toLowerCase()]: "libertad",
            [t('categorias.categoria-3').toLowerCase()]: "arte-y-cultura",
            [t('categorias.categoria-6').toLowerCase()]: "innovacion",
            [t('categorias.categoria-9').toLowerCase()]: "prosperidad-incluyente",
            [t('categorias.categoria-8').toLowerCase()]: "biblioteca",
        };
    
        return reverseCategoryMap[categoryName.toLowerCase()] || "";
    };

    const truncateText = (text, limit) => {
        if (!text) return "";

        const cleanText = cleanResumen(text);

        if (cleanText.length <= limit) {
            return cleanText;
        }

        return cleanText.slice(0, limit).trim() + "...";
    };

    const isFilteredView = isSearchMode || activeCategory;

    return (
        <>
            <section class="blog-page">
                <div class="_nghost-ng-c2416121091">
                    <header class="blog-header">
                        <div class="blog-header__inner">
                            <h1 class="blog-header__title">{(t('header.explora'))}</h1>
                            <nav aria-label="Categorías" class="blog-header__categories">

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "liderazgo" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("liderazgo")}
                                >
                                    {(t('categorias.categoria-5'))}
                                </button>

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "educacion" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("educacion")}
                                >
                                    {(t('categorias.categoria-2'))}
                                </button>

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "estado-de-derecho" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("estado-de-derecho")}
                                >
                                    {(t('categorias.categoria-7'))}
                                </button>

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "medio-ambiente" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("medio-ambiente")}
                                >
                                    {(t('categorias.categoria-4'))}
                                </button>

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "libertad" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("libertad")}
                                >
                                    {(t('categorias.categoria-1'))}
                                </button>

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "arte-y-cultura" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("arte-y-cultura")}
                                >
                                    {(t('categorias.categoria-3'))}
                                </button>

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "innovacion" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("innovacion")}
                                >
                                    {(t('categorias.categoria-6'))}
                                </button>

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "prosperidad-incluyente" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("prosperidad-incluyente")}
                                >
                                    {(t('categorias.categoria-9'))}
                                </button>

                                <button
                                    type="button"
                                    class={`blog-header__category ${activeCategory === "biblioteca" ? "blog-header__category--active" : ""}`}
                                    onClick={() => handleCategoryClick("biblioteca")}
                                >
                                    {(t('categorias.categoria-8'))}
                                </button>

                            </nav>
                            <div aria-label="Controles del blog" class="blog-header__controls"><label
                                class="blog-header__control blog-header__control--sort"><span
                                    class="blog-header__visually-hidden">{(t('filtro.ordenar-fecha2'))}</span><select
                                        value={sortOrder}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            setSortOrder(value);
                                            setOffset(0);

                                            fetchBlogs({
                                                category: activeCategory,
                                                search: searchTerm,
                                                offset: 0,
                                                sort: value
                                            });
                                        }}
                                    >
                                    <option value="recent">{(t('filtro.ordenar-fecha-op1'))}</option>
                                    <option value="old">{(t('filtro.ordenar-fecha-op2'))}</option>
                                </select></label>
                                <div class="blog-header__control blog-header__control--search"><label
                                ><span
                                    class="blog-header__visually-hidden">Buscar publicaciones</span>
                                    <input
                                        type="search"
                                        placeholder={(t('filtro.buscar'))}
                                        value={searchInput}
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                handleSearch();
                                            }
                                        }}
                                    />

                                    {searchTerm && (
                                        <button
                                            type="button"
                                            aria-label="Limpiar búsqueda"
                                            class="blog-header__search-button"
                                            onClick={resetFilters}
                                        >
                                            <img
                                                src="/assets/img2026/cerrar-cancelar.svg"
                                                alt="cancelar"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    )}

                                    {!searchTerm && (
                                        <button
                                            type="button"
                                            aria-label="Buscar publicaciones"
                                            class="blog-header__search-button"
                                            onClick={handleSearch}
                                        >
                                            <img
                                                src="/assets/img2026/logo_search.svg"
                                                alt="Buscar"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    )}


                                </label>
                                </div>
                            </div>
                        </div>
                    </header>
                </div>
                <div className="blogs-cont-min">
                    {!loading && (variableRetornada === 0 || variableRetornada > 400) && sortedBlogs.length === 0 && (
                        <div class="_nghost-ng-c2806470063">
                            <section class="">
                                <div class="blog-hero-article__inner">
                                    <div className="blog-empty-state">
                                        <h2>{t2("general.noresults")}</h2>
                                        <p>
                                            {t2("general.noresults1")}
                                            {searchTerm && `: "${searchTerm}"`}
                                        </p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    )}
                    {(loading || sortedBlogs.length > 0) && (
                        <>
                            {isFilteredView ? (

                                // 🔎 RESULTADOS SIMPLES DE BÚSQUEDA
                                <>
                                    {/* 🔎 RESULTADOS DESKTOP */}
                                    <div className="_nghost-ng-c732107720">

                                        <section
                                            aria-label="Resultados de búsqueda"
                                            className="blog-image-cards-row"
                                        >


                                            <h4 className="title-busq-in">
                                                {!loading && !activeCategory && (
                                                    t("header.busqueda1")
                                                )}
                                            </h4>


                                            <div className="blog-image-cards-row__inner">

                                                {loading
                                                    ? Array.from({ length: 8 }).map((_, i) => (
                                                        <SkeletonCard
                                                            key={i}
                                                            type="imageCard"
                                                        />
                                                    ))
                                                    : sortedBlogs.map((item, i) => (

                                                        <article
                                                            key={i}
                                                            className="blog-image-cards-row__card"
                                                            tabIndex="0"
                                                        >

                                                            <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} target="_blank" href={'/blog/' + item.tag}>

                                                                <img
                                                                    loading="lazy"
                                                                    src={item.urlImagen}
                                                                    alt={item.titulo}
                                                                />

                                                                <div className="blog-image-cards-row__meta">

                                                                    <p className="blog-image-cards-row__tag">
                                                                        <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + getCategoryTag(getCategoryName(item))}>
                                                                            {getCategoryName(item)}
                                                                        </a>
                                                                    </p>

                                                                    <p className="blog-image-cards-row__meta-text">
                                                                        {formatDate(item.fecha)} · {getReadingTime(item.resumen)}
                                                                    </p>

                                                                </div>

                                                                <h3>
                                                                    {item.titulo}
                                                                </h3>

                                                                <p className="blog-image-cards-row__excerpt">
                                                                    {truncateText(item.resumen, 180)}
                                                                </p>

                                                            </a>

                                                        </article>
                                                    ))}
                                            </div>

                                        </section>

                                    </div>

                                    {/* 📱 RESULTADOS MOBILE */}
                                    <div
                                        arialabel="Resultados móviles"
                                        className="_nghost-ng-c2676785337"
                                    >

                                        <section
                                            className="blog-mobile-stories"
                                            aria-label="Resultados móviles"
                                        >

                                            {!loading && !activeCategory && (
                                                <h4 className="title-busq-in">
                                                    {t("header.busqueda1")}
                                                </h4>
                                            )}

                                            <div className="blog-mobile-stories__inner">

                                                {loading
                                                    ? Array.from({ length: 4 }).map((_, i) => (
                                                        <SkeletonCard
                                                            key={i}
                                                            type="vertical"
                                                        />
                                                    ))
                                                    : sortedBlogs.map((item, i) => (

                                                        <article
                                                            key={i}
                                                            className="blog-mobile-stories__story"
                                                            tabIndex="0"
                                                        >

                                                            <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} target="_blank" href={'/blog/' + item.tag}>

                                                                <img
                                                                    loading="lazy"
                                                                    src={item.urlImagen}
                                                                    alt={item.titulo}
                                                                />

                                                                <p className="blog-mobile-stories__tag">
                                                                    <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                        {getCategoryName(item)}
                                                                    </a>
                                                                </p>

                                                                <p className="blog-mobile-stories__meta">
                                                                    {formatDate(item.fecha)} · {getReadingTime(item.resumen)}
                                                                </p>

                                                                <h3>
                                                                    {item.titulo}
                                                                </h3>

                                                                <p className="blog-mobile-stories__excerpt">
                                                                    {truncateText(item.resumen, 110)}
                                                                </p>

                                                            </a>

                                                        </article>
                                                    ))}
                                            </div>

                                        </section>

                                    </div>

                                    <div class="blog-page__load-more-wrap">
                                        {hasMore && (
                                            <button
                                                type="button"
                                                class="blog-page__load-more-button"
                                                onClick={() => {loadMore(); trackAnalyticsClick('Mi Blog - Mas blogs')}}
                                                disabled={loadingMore}
                                            >
                                                {loadingMore ? (t('header.cargando')) : (t('header.exploramas'))}
                                            </button>)}
                                    </div>

                                </>

                            ) : (

                                // 🎨 LAYOUT NORMAL ORIGINAL
                                <>
                                    <div class="_nghost-ng-c2806470063">
                                        <section class="blog-hero-article">
                                            <div class="blog-hero-article__inner">
                                                {loading ? (
                                                    <SkeletonCard type="hero" />
                                                ) : sortedBlogs[0] && (
                                                    <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+sortedBlogs[0].titulo)} href={'/blog/' + sortedBlogs[0].tag}>
                                                        <article class="blog-hero-article__card" tabIndex="0">
                                                            <img
                                                                class="blog-hero-article__image"
                                                                src={sortedBlogs[0].urlImagen}
                                                                alt={sortedBlogs[0].titulo}
                                                            />
                                                            <div class="blog-hero-article__content">
                                                                <p class="blog-hero-article__tag">
                                                                    <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + sortedBlogs[0].categorias[0].tagCategory.toLowerCase()}>
                                                                        {getCategoryName(sortedBlogs[0])}
                                                                    </a>
                                                                </p>
                                                                <h2 class="blog-hero-article__title">
                                                                    {sortedBlogs[0].titulo}
                                                                </h2>
                                                                <p class="blog-hero-article__excerpt">
                                                                    {truncateText(sortedBlogs[0].resumen, 180)}
                                                                </p>
                                                                <p class="blog-hero-article__meta">
                                                                    {formatDate(sortedBlogs[0].fecha)} · {getReadingTime(sortedBlogs[0].resumen)}{t("header.tiempo2")}
                                                                </p>
                                                            </div>
                                                        </article>
                                                    </a>
                                                )}
                                            </div>
                                        </section>
                                    </div>

                                    <div arialabel="Historias móviles" class="_nghost-ng-c2676785337">
                                        <section class="blog-mobile-stories" aria-label="Historias móviles">
                                            <div class="blog-mobile-stories__inner">
                                                {loading
                                                    ? Array.from({ length: 4 }).map((_, i) => (
                                                        <SkeletonCard key={i} type="vertical" />
                                                    ))
                                                    : sortedBlogs.slice(1, 11).map((item, i) => (
                                                        <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}>
                                                            <article key={i} class="blog-mobile-stories__story" tabIndex="0">
                                                                <img loading="lazy" src={item.urlImagen} alt={item.titulo} />
                                                                <p class="blog-mobile-stories__tag">
                                                                    <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                        {getCategoryName(item)}
                                                                    </a>
                                                                </p>
                                                                <p class="blog-mobile-stories__meta">{formatDate(item.fecha)} · {getReadingTime(item.resumen)}{t("header.tiempo2")}</p>
                                                                <h3 >{item.titulo}</h3>
                                                                <p class="blog-mobile-stories__excerpt">{truncateText(item.resumen, 110)}</p>
                                                            </article>
                                                        </a>
                                                    ))}
                                            </div>
                                        </section>
                                    </div>
                                    {sortedBlogs.length > 1 && (
                                        <div
                                            arialabel="Historias destacadas" class="_nghost-ng-c1244515913">
                                            <section class="blog-text-cards-row" aria-label="Historias destacadas">
                                                <div class="blog-text-cards-row__inner">
                                                    {!loading && sortedBlogs.slice(1, 4).map((item, i) => (

                                                        <article key={i} class="blog-text-cards-row__card" tabIndex="0">
                                                            <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}>
                                                                <p class="blog-text-cards-row__tag">
                                                                    <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                        {getCategoryName(item)}
                                                                    </a>
                                                                </p>
                                                                <h3>{item.titulo}</h3>
                                                                <p class="blog-text-cards-row__excerpt">
                                                                    {truncateText(item.resumen, 120)}
                                                                </p>
                                                                <p class="blog-text-cards-row__meta">
                                                                    {formatDate(item.fecha)} · {getReadingTime(item.resumen)}
                                                                </p>
                                                            </a>
                                                        </article>
                                                    ))}
                                                </div>
                                            </section>
                                        </div>
                                    )}
                                    {sortedBlogs.length > 4 && (
                                        <div class="_nghost-ng-c1138810464">
                                            <section class="blog-feature-split">
                                                <div class="blog-feature-split__inner">
                                                    {!loading && sortedBlogs[4] && (
                                                        <>

                                                            <article class="blog-feature-split__story" tabindex="0">
                                                                <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+sortedBlogs[4].titulo)} href={'/blog/' + sortedBlogs[4].tag}>
                                                                    <p class="blog-feature-split__tag">
                                                                        <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + sortedBlogs[0].categorias[0].tagCategory.toLowerCase()}>
                                                                            {getCategoryName(sortedBlogs[0])}
                                                                        </a></p>
                                                                    <h3 >{sortedBlogs[4].titulo}</h3>
                                                                    <p class="blog-feature-split__story-excerpt">{truncateText(sortedBlogs[4].resumen, 180)}</p>
                                                                    <p class="blog-feature-split__meta">{formatDate(sortedBlogs[4].fecha)} · {getReadingTime(sortedBlogs[4].resumen)}{t("header.tiempo2")}</p>
                                                                </a>
                                                            </article>

                                                            <img loading="lazy" class="blog-feature-split__image"
                                                                src={sortedBlogs[4].urlImagen} alt={sortedBlogs[4].titulo} tabindex="0" onClick={() => navigate(`/blog/${sortedBlogs[4].tag}`)} />

                                                        </>
                                                    )}
                                                    <aside aria-label="Más publicaciones" class="blog-feature-split__list">
                                                        {!loading && sortedBlogs.slice(5, 8).map((item, i) => (

                                                            <article key={i} class="blog-feature-split__list-item" tabIndex="0">
                                                                <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}>
                                                                    <p class="blog-feature-split__tag">
                                                                        <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                            {getCategoryName(item)}
                                                                        </a>
                                                                    </p>
                                                                    <h4>{item.titulo}</h4>
                                                                    <p class="blog-feature-split__list-excerpt">
                                                                        {truncateText(item.resumen, 120)}
                                                                    </p>
                                                                    <p class="blog-feature-split__meta">
                                                                        {formatDate(item.fecha)} · {getReadingTime(item.resumen)}
                                                                    </p></a>
                                                            </article>

                                                        ))}
                                                    </aside>
                                                </div>
                                            </section>
                                        </div>
                                    )}

                                    {sortedBlogs.length > 5 && (
                                        <div arialabel="Más historias" className="_nghost-ng-c1244515913 blog-feature-split__list_tablet">
                                            <section class="blog-text-cards-row blog-text-cards-row--second"
                                                aria-label="Más historias">
                                                <div class="blog-text-cards-row__inner">
                                                    {!loading && sortedBlogs.slice(5, 8).map((item, i) => (

                                                        <article class="blog-text-cards-row__card" tabindex="0">
                                                            <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}>
                                                                <p class="blog-text-cards-row__tag">
                                                                    <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                        {getCategoryName(item)}
                                                                    </a>
                                                                </p>
                                                                <h3 >{item.titulo}</h3>
                                                                <p class="blog-text-cards-row__excerpt">{truncateText(item.resumen, 120)}</p>
                                                                <p class="blog-text-cards-row__meta">{formatDate(item.fecha)} · {getReadingTime(item.resumen)}</p>
                                                            </a></article>

                                                    ))}
                                                </div>
                                            </section>
                                        </div>
                                    )}

                                    {sortedBlogs.length > 8 && (
                                        <div arialabel="Más historias" className="_nghost-ng-c1244515913">
                                            <section class="blog-text-cards-row blog-text-cards-row--second"
                                                aria-label="Más historias">
                                                <div class="blog-text-cards-row__inner">
                                                    {!loading && sortedBlogs.slice(8, 11).map((item, i) => (

                                                        <article class="blog-text-cards-row__card" tabindex="0">
                                                            <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}>
                                                                <p class="blog-text-cards-row__tag">
                                                                    <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                        {getCategoryName(item)}
                                                                    </a></p>
                                                                <h3 >{item.titulo}</h3>
                                                                <p class="blog-text-cards-row__excerpt">{truncateText(item.resumen, 120)}</p>
                                                                <p class="blog-text-cards-row__meta">{formatDate(item.fecha)} · {getReadingTime(item.resumen)}</p>
                                                            </a></article>

                                                    ))}
                                                </div>
                                            </section>
                                        </div>
                                    )}
                                    <div class="_nghost-ng-c3151073329">
                                        <section aria-label="Suscripción al boletín" class="blog-newsletter-cta">
                                            <div class="blog-newsletter-cta__container">
                                                <p class="blog-newsletter-cta__message"><span
                                                    class="blog-newsletter-cta__message-desktop">{(t2('general.suscribirsel4'))}</span><span
                                                        class="blog-newsletter-cta__message-mobile">{(t2('general.suscribirsel4'))}</span></p><button
                                                            type="button" class="blog-newsletter-cta__button" onClick={() => {openModal2();trackAnalyticsClick('Mi Blog - Suscribirse');}} ><span
                                                                class="blog-newsletter-cta__button-desktop">{(t2('general.suscribirsebtn4'))}</span><span
                                                                    class="blog-newsletter-cta__button-mobile">{(t2('general.suscribirsebtn4'))}</span></button>
                                            </div>
                                        </section>
                                    </div>
                                    {sortedBlogs.length > 11 && (
                                        <div class="_nghost-ng-c732107720">
                                            <section aria-label="Historias con imagen" class="blog-image-cards-row">
                                                <div class="blog-image-cards-row__inner">
                                                    {loading
                                                        ? Array.from({ length: 4 }).map((_, i) => (
                                                            <SkeletonCard key={i} type="imageCard" />
                                                        ))
                                                        : sortedBlogs.slice(11, 15).map((item, i) => (

                                                            <article class="blog-image-cards-row__card" tabindex="0">
                                                                <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}><img
                                                                    loading="lazy" src={item.urlImagen} alt={item.titulo} />
                                                                    <div class="blog-image-cards-row__meta">
                                                                        <p class="blog-image-cards-row__tag">
                                                                            <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                                {getCategoryName(item)}
                                                                            </a>
                                                                        </p>
                                                                        <p class="blog-image-cards-row__meta-text">{formatDate(item.fecha)} · {getReadingTime(item.resumen)}</p>
                                                                    </div>
                                                                    <h3 >{item.titulo}</h3>
                                                                    <p class="blog-image-cards-row__excerpt">{truncateText(item.resumen, 180)}</p>
                                                                </a></article>
                                                        ))}
                                                    {sortedBlogs.length > 15 && (
                                                        <>
                                                            {sortedBlogs.slice(15).map((item, i) => (
                                                                <article key={i} class="blog-image-cards-row__card" tabIndex="0">
                                                                    <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}>
                                                                        <img
                                                                            loading="lazy"
                                                                            src={item.urlImagen}
                                                                            alt={item.titulo}
                                                                        />

                                                                        <div class="blog-image-cards-row__meta">
                                                                            <p class="blog-image-cards-row__tag">
                                                                                <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                                    {getCategoryName(item)}
                                                                                </a>
                                                                            </p>

                                                                            <p class="blog-image-cards-row__meta-text">
                                                                                {formatDate(item.fecha)} · {getReadingTime(item.resumen)}
                                                                            </p>
                                                                        </div>

                                                                        <h3>{item.titulo}</h3>

                                                                        <p class="blog-image-cards-row__excerpt">
                                                                            {truncateText(item.resumen, 180)}
                                                                        </p>
                                                                    </a>
                                                                </article>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            </section>
                                        </div>
                                    )}
                                    <div
                                        arialabel="Más historias móviles" variant="late" className="_nghost-ng-c2676785337">
                                        <section class="blog-mobile-stories" aria-label="Más historias móviles">
                                            <div class="blog-mobile-stories__inner">
                                                {!loading && sortedBlogs.slice(11, 15).map((item, i) => (

                                                    <article key={i}
                                                        class="blog-mobile-stories__story blog-mobile-stories__story--late" tabindex="0">
                                                        <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}>
                                                            <img
                                                                loading="lazy" src={item.urlImagen}
                                                                alt={item.titulo} />
                                                            <p class="blog-mobile-stories__tag">
                                                                <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                    {getCategoryName(item)}
                                                                </a></p>
                                                            <p class="blog-mobile-stories__meta">{formatDate(item.fecha)} · {getReadingTime(item.resumen)}{t("header.tiempo2")}</p>
                                                            <h3 >{item.titulo}</h3>
                                                            <p class="blog-mobile-stories__excerpt">{truncateText(item.resumen, 110)}</p>
                                                        </a></article>

                                                ))}
                                                {sortedBlogs.length > 15 && (
                                                    <>
                                                        {sortedBlogs.slice(15).map((item, i) => (
                                                            <article key={i}
                                                                class="blog-mobile-stories__story blog-mobile-stories__story--late" tabindex="0">
                                                                <a onClick={() => trackAnalyticsClick('Mi Blog - Blogs: '+item.titulo)} href={'/blog/' + item.tag}>
                                                                    <img
                                                                        loading="lazy" src={item.urlImagen}
                                                                        alt={item.titulo} />
                                                                    <p class="blog-mobile-stories__tag">
                                                                        <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                                            {getCategoryName(item)}
                                                                        </a>
                                                                    </p>
                                                                    <p class="blog-mobile-stories__meta">{formatDate(item.fecha)} · {getReadingTime(item.resumen)}{t("header.tiempo2")}</p>
                                                                    <h3 >{item.titulo}</h3>
                                                                    <p class="blog-mobile-stories__excerpt">{truncateText(item.resumen, 110)}</p>
                                                                </a></article>
                                                        ))}
                                                    </>
                                                )}
                                            </div>
                                        </section>
                                    </div >


                                    <div class="blog-page__load-more-wrap">
                                        {hasMore && (
                                            <button
                                                type="button"
                                                class="blog-page__load-more-button"
                                                onClick={() => {loadMore(); trackAnalyticsClick('Mi Blog - Mas blogs')}}
                                                disabled={loadingMore}
                                            >
                                                {loadingMore ? (t('header.cargando')) : (t('header.exploramas'))}
                                            </button>)}
                                    </div>
                                </>

                            )}

                        </>
                    )}

                </div>

                {isFilteredView ? (
                    <Busqueda_cont cadena={searchTerm} datee={null} onRetorno={handleRetorno} />
                ) : (
                    <>
                    </>
                )}

                <div class="_nghost-ng-c3151073329">
                    <section aria-label="Suscripción al boletín" class="blog-newsletter-cta">
                        <div class="blog-newsletter-cta__container">
                            <p class="blog-newsletter-cta__message"><span
                                class="blog-newsletter-cta__message-desktop" >{t('header.recomend1')}<br className="only-desk" />{t('header.recomend1_1')}</span><span
                                    class="blog-newsletter-cta__message-mobile">{t('header.recomend2')}</span></p><button
                                        type="button" class="blog-newsletter-cta__button" onClick={() => {setShowIdeasModal(true);trackAnalyticsClick('Mi Blog - Propuesta Tema');}}><span
                                            class="blog-newsletter-cta__button-desktop">{t('header.recomendbtn')}</span><span
                                                class="blog-newsletter-cta__button-mobile">{t('header.recomendbtn')}</span></button>
                        </div>
                    </section>
                </div>

                <IdeasForm
                    isOpen={showIdeasModal}
                    closeModal={() => setShowIdeasModal(false)}
                />
                <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
            </section >
        </>
    );
};
export default Blogs;
